import React from 'react';
import {Button, Flex, Modal} from "antd";
import CustomButton from "../../../../../../components/UI/CustomButton/CustomButton";
import './CompanyVerificationModal.scss'

interface CompanyVerificationModalProps {
  visible: boolean;
  onClose: () => void;
}

const CompanyVerificationModal = ({visible, onClose}: CompanyVerificationModalProps) => {
  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      centered
      closable={false}
      className="CompanyVerificationModal"
    >
      <Flex vertical justify={"center"} align={"center"} gap={'50px'} className="CompanyVerificationModal__content">
        <Flex vertical gap={'13px'} className="CompanyVerificationModal__header">
          <h2 className="CompanyVerificationModal__header__title">Verification request sent </h2>
          <p className="CompanyVerificationModal__header__description">
            The request for confirmation has been sent. Once the company verifies you as an employee, we will update your status.
          </p>
        </Flex>
        <Flex gap={'30px'} vertical className="CompanyVerificationModal__button">
          <CustomButton text={'Ok'} disable={false} onClick={() => onClose()}/>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default CompanyVerificationModal;